import axios from 'axios'
import router from '@/router'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { convertEmptyStringsToNull, tansParams } from '@/utils/public'

import { ElMessage } from 'element-plus'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: '',
    // 超时
    timeout: 60000,
})

// request拦截器
service.interceptors.request.use((config) => {

    const token = getToken()
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
    // 处理 GET 请求的参数
    if (config.method === 'get') {
        // 处理查询参数
        const data = new URLSearchParams(config.data).toString();
        // 构建新的 URL
        const url = `${config.url}?${data}`;
        // 更新 config 对象
        config.url = url;
        config.params = {};
    }

    // 处理 POST 请求，防止数据重复提交
    // if (config.method === 'post') {
    //     const data = convertEmptyStringsToNull(config.data);
    //     // 保存请求对象
    //     const requestObj = {
    //         url: config.url,
    //         data: typeof data === 'object' ? JSON.stringify(config.data) : data,
    //         time: new Date().getTime(),
    //     };
    //
    // }

    return config;
}, (error) => {
    return Promise.reject(error);
});


// 响应拦截器
service.interceptors.response.use(
    (res) => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 0
        // 获取错误信息
        const msg = res.data.message
        // 二进制数据则直接返回
        if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
            return res.data
        }
        if (res.data.code === 401) { // 添加token过期处理
            removeToken()
            router.push('/login')
          }
        if (code !== 0) {
            ElMessage.error(msg)
            return Promise.reject(new Error(msg))
        }
        return Promise.resolve(res.data)
    },
    (error) => {
        if (error.response.status === 401) {
            removeToken()
            router.push('/login')
          }
        if (error) {
            let { message } = error
            if (message == 'Network Error') {
                message = '后端接口连接异常'
            } else if (message.includes('timeout')) {
                message = '系统接口请求超时'
            } else if (message.includes('Request failed with status code')) {
                message = `系统接口${message.substr(message.length - 3)}异常`
            }
            ElMessage.error(message)
            return Promise.reject(error)
        }
    },
)
export default service
